import { Box, Typography } from '@mui/material';
import STITCH_TYPES from './stitchTypes';
import StitchSymbol from './StitchSymbol';

const KeyPanel = ({ grid, cellSize = 24 }) => {
  // Collect all unique, non-blank, non-null stitch keys used in the grid
  const usedStitches = new Set();
  grid.forEach(row => row.forEach(stitch => {
    if (stitch && stitch !== 'blank' && stitch !== null && STITCH_TYPES[stitch] && !STITCH_TYPES[stitch].isBlank) {
      usedStitches.add(stitch);
    }
  }));
  const usedStitchKeys = Array.from(usedStitches);
  // Sort by order in STITCH_TYPES
  const stitchTypeOrder = Object.keys(STITCH_TYPES);
  usedStitchKeys.sort((a, b) => stitchTypeOrder.indexOf(a) - stitchTypeOrder.indexOf(b));
  // Find the widest stitch
  let maxWidth = 1;
  usedStitchKeys.forEach(key => {
    const w = STITCH_TYPES[key]?.width || 1;
    if (w > maxWidth) maxWidth = w;
  });
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle" gutterBottom>STITCH KEY</Typography>
      <Box component="table" sx={{ width: 'auto', borderCollapse: 'separate', borderSpacing: 0, mt: 1 }}>
        <tbody>
          {usedStitchKeys.map((key) => {
            const stitch = STITCH_TYPES[key];
            const width = stitch.width || 1;
            return (
              <tr key={key}>
                <td style={{ width: cellSize * maxWidth, padding: 0, verticalAlign: 'middle' }}>
                  <Box sx={{
                    width: cellSize * width,
                    height: cellSize,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'white',
                    border: '1px solid #e0e0e0',
                    mb: 1
                  }}>
                    <StitchSymbol type={key} isRS={true} cellSize={cellSize} />
                  </Box>
                </td>
                <td style={{ paddingLeft: 8, verticalAlign: 'middle' }}>
                  <Typography variant="body2">{stitch.description || key}</Typography>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Box>
    </Box>
  );
};

export default KeyPanel;
